export interface JoinFinnairPlusRequestData {
  firstName: string;
  lastName: string;
  email: string;
  dateOfBirth: string;
  gender: string;
  phoneNumber?: string;
  password?: string;
  /** Format: language | language-COUNTRYCODE */
  locale: string;
  countryCode: string;
  agreements?: boolean;
  enrollmentChannel: string;
  marketingPermissions?: Record<string, boolean>;
  consent?: boolean;
  guardianName?: string;
  guardianEmail?: string;
  guardianPhoneNumber?: string;
  guardianMemberNumber?: string;
}

export interface JoinFinnairPlusResponseData {
  memberNumber: string;
  status: {
    message: StatusCode;
  };
}

export interface VerifyFinnairPlusResponseData {
  status: {
    message: StatusCode;
  };
}

export interface ConfirmFinnairPlusResponseData {
  memberNumber: string;
}

export enum StatusCode {
  OK = 'OK',
  ERROR = 'ERROR',
}

export interface JoinFinnairPlusErrorResponseData {
  reason?: string;
  status: {
    message?: StatusCode;
    fieldErrors?: Array<{ errorMessage: string }>;
  };
}

export interface VerifyAccountTokenErrorResponseData {
  status: {
    message: StatusCode.ERROR;
  };
  reason: string;
}

export function isVerifyAccountTokenErrorResponseData(error: unknown): error is VerifyAccountTokenErrorResponseData {
  return Boolean((error as VerifyAccountTokenErrorResponseData)?.reason);
}

export const MOBILE_APP_CHANNEL = 'mobile';
